module.exports = __webpack_public_path__ + "img/member_logo.cfaaee8.png";